import { Tag } from '@uigovpe/components';
import {
  RequestStatus,
  STATUS_LABELS,
  STATUS_SEVERITIES,
} from '@/shared/types/certificate-request';

export function StatusTag({ status }: { status: RequestStatus }) {
  return <Tag value={STATUS_LABELS[status] ?? status} severity={STATUS_SEVERITIES[status]} />;
}
